<template>
  <div>
    <!-- Form -->
    <div class="card">
      <div class="card-header border-bottom">
        <div class="title-wrap">
          <b-form-row class="align-items-end">
            <b-col md="9">
              <b-input-group>
                <b-form-input name="title"
                              id="title"
                              size="lg"
                              placeholder="보고서 양식명을 입력해주세요"
                              v-model="template.title"
                              ref="title"
                              v-validate="{ required: true }"
                              :state="validateState('title')"/>
              </b-input-group>
            </b-col>
          </b-form-row>
        </div>
      </div>

      <div class="card-body">
        <b-form>
          <div class="form-wrap">
            <b-form-row>
              <b-col md="6">
                <label for="description">설명</label>
                <b-form-textarea
                    rows="5"
                    id="description"
                    name="description"
                    placeholder="보고서 양식에 대한 설명을 입력해주세요"
                    v-model="template.description"
                    v-validate="{ required: true }"
                    :state="validateState('description')"
                    style="border-color:lightgray; border-radius : 7px;"
                />
              </b-col>
            </b-form-row>
          </div>
        </b-form>
      </div>
    </div>
    <!-- /Form -->

    <!-- Table of Contents -->
    <div class="table-of-contents-wrap">
      <div class="card">
        <div class="card-header">
          <div class="card-title-area">
            <b-icon icon="gear-wide-connected"/>
            <span class="title-text">목차</span>
          </div>
        </div>

        <div class="card-body">
          <esg-toc-template-management-grid :data="template.tableOfContents"
                                            :deleted-items="template.deletedItems"
                                            ref="tocManagementGrid"/>
        </div>
      </div>
    </div>
    <!-- Table of Contents -->
  </div>
</template>

<script>
import EsgTocTemplateManagementGrid
  from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/EsgDisclosureTemplateManagementGrid.vue";

export default {
  name: "DisclosureTemplateForm",
  components: { EsgTocTemplateManagementGrid },
  props: {
    template: {
      type: Object,
      required: true
    },
  },
  created() {
    // Custom error messages
    const customDictionary = {
      custom: {
        title: {
          required: '보고서 양식명을 입력해주세요',
        },
        description: {
          required: '보고서 양식에 대한 설명을 입력해주세요',
        },
      }
    };
    this.$validator.localize('kr', customDictionary);
  },
  methods: {
    validate() {
      return this.validateForm();
    }
  }
}
</script>

<style scoped>
/* card */
.card {
  padding: max(2rem, 1.5vw) 2vw;
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.card-header {
  padding: 0;
  border-bottom: none;
}

.card-body {
  padding: 0;
}

/* Table of Contents */
.table-of-contents-wrap .card .card-header {
  padding-bottom: 2rem;
}

.table-of-contents-wrap .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

.table-of-contents-wrap .card-title-area .title-text {
  font-family: NanumGothic;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

/* form */
.card .card-header .title-wrap {
  margin-top: unset;
  margin-bottom: 1rem;
}

.card .card-header .title-wrap .form-control {
  background-color: transparent;
  font-weight: 700;
  height: 45px;
  font-size: 30px;
  padding-right: 0.7812vw;
  padding-left: 0.7812vw;
  border: none;
}

.card .card-header .title-wrap .form-control::placeholder {
  font-size: 1.5rem;
}

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  color: #FFE600 !important;
  background-color: #0D0D17 !important;
  border-color: transparent !important;
  box-shadow: unset;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-secondary {
  width: 148px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.btn-secondary.small {
  height: 40px;
}

.btn-secondary:hover {
  background-color: #565662;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-delete,
.badge-container .btn-delete {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
}

.btn-file-download {
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  border: 1px solid #C4C4CD;
  background-color: #FFF;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin-top: 1.333rem;
}

.btn-file-download:hover {
  border: 1px solid #747480;
}

/* 공통요소 */
span.required {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #FF0000;
  border-radius: 50%;
  font-size: 0;
}

.border-bottom {
  border-bottom: 1px solid #DDDDE3;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.flex-grow {
  flex-grow: 1;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 20px;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #F6F6FA;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* select */
.custom-select {
  padding: 0.5rem 2rem 0.5rem 1rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  text-overflow: ellipsis;
}

.custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-select.is-valid {
  border: 1px solid #00A438;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
  url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-invalid {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
  url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-valid:focus {
  box-shadow: none;
  border: 1px solid #00A438;
}

.custom-select.is-invalid:focus {
  box-shadow: none;
  border: 1px solid #FF0000;
}

.custom-select#project-list {
  padding: 0.266rem 0.8rem 0.266rem 1.2rem;
  border-radius: 38px;
  background-color: #E4E4EA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 7px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

/* custom select */
.custom-select-area {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
  margin-bottom: 1.5625vw;
}

.custom-select-box {
  position: relative;
  width: fit-content;
  min-width: 180px;
  text-align: left;
  cursor: default;
  font-family: 'NanumGothic';
}

.custom-select-box .select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  width: 100%;
  height: 35px;
  padding-left: 1.2rem;
  padding-right: 0.8rem;
  border-radius: 38px;
  border: 1px solid transparent;
  background-color: #E4E4EA;
}

.custom-select-box .select .text {
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: #747480;
  line-height: 1.8;
  appearance: none;
}

.custom-select-box .select .icon-arrow {
  display: block;
  width: 20px;
  height: 21px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8333 8L9.99992 13.8333L4.16659 8" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.custom-select-box .select .text::after {
  content: '';
  display: block;
  position: absolute;
  top: 8px;
  right: -6px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #FF0000;
}

.custom-select-box.active .select {
  background-color: #fff;
  border-color: #000;
}

.custom-select-box.active .select .text {
  color: #2E2E38;
}

.custom-select-box.active .select .text::after {
  content: none;
}

.custom-select-box.active .select .icon-arrow {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.custom-select-box .opt-list {
  display: none;
  position: absolute;
  top: 3.066rem;
  left: 0;
  z-index: 150;
  width: 100%;
  max-height: 200px;
  padding: 0.4rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  list-style: none;
  overflow-y: auto;
}

.custom-select-box .opt-list .opt-inner {
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  background-color: #F6F6FA;
  color: #747480;
  font-size: 12px;
  font-weight: 500;
}

.custom-select-box.active .opt-list {
  display: block;
}

.custom-select-box .opt-item:hover .opt-inner {
  background-color: #E7E7EE;
  color: #2E2E38;
  font-weight: 700;
}

/* input */
.form-group {
  margin-bottom: 0;
}


label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.custom-input,
input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-input.small {
  width: min(15.866rem, 12.395vw);
}

.form-control:focus {
  box-shadow: none;
  border-color: unset;
}

.form-control.is-valid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>');
}

.form-control.is-invalid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>');
}

.form-control.is-valid:focus {
  box-shadow: 0 0 0 1px #00A438;
}

.form-control.is-invalid:focus {
  box-shadow: 0 0 0 1px #FF0000;
}

.input-group:not(.has-validation) > .form-control:not(:last-child) {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-file {
  height: 2.666rem;
}

/* form */
.form-wrap {
  padding: 2.0833vw 0 0.5208vw;
}

.form-wrap:last-child {
  padding: 2.0833vw 0 0;
}

.form-row {
  margin-left: -0.7812vw;
  margin-right: -0.7812vw;
}

.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
  margin-bottom: 1.5625vw;
}

.invalid-feedback {
  position: absolute;
  margin-top: 2px;
  padding-left: 6px;
  color: #FF0000;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

/* card 영역 */
.card {
  padding: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card-header {
  padding: 0;
  border-bottom: none;
}

.card-body {
  padding: 0;
}

.card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

.card .title-wrap {
  margin-top: -0.666rem;
}

.card .title-wrap {
  margin-top: -0.666rem;
}

/* Prevents Bootstrap default settings from impacting buttons in 'Active' state */
.btn-primary:not(:disabled):not(.disabled):focus {
  background: #747480;
  border-color: #747480;
}

.btn-primary:not(:disabled):not(.disabled):active {
  background: #747480;
  border-color: #747480;
}
</style>